import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("scwt_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Field pages (technician magic-link sessions) — an expired/lost session
// must bounce to the magic-link login and return to the same job after
// verification, never strand the tech on a "Not authenticated" toast.
api.interceptors.response.use(undefined, (error) => {
  const p = window.location.pathname;
  if (error.response?.status === 401 && p.startsWith("/field/")
      && !p.startsWith("/field/login") && !p.startsWith("/field/verify")) {
    localStorage.removeItem("scwt_token");
    const next = encodeURIComponent(p + window.location.search);
    window.location.assign(`/field/login?next=${next}`);
  }
  // Staff pages (admin + lab) — an expired/purged session must bounce to
  // the unified login with a clear "session expired" banner and return to
  // the same page after sign-in, never strand staff on a raw
  // "Not authenticated" toast (e.g. inside the Create Booking modal).
  if (error.response?.status === 401
      && (p.startsWith("/admin") || p.startsWith("/lab"))) {
    localStorage.removeItem("scwt_token");
    const next = encodeURIComponent(p + window.location.search);
    window.location.assign(`/login?expired=1&next=${next}`);
  }
  return Promise.reject(error);
});

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  // Unwrap an axios error: prefer the server-supplied response.data.detail.
  if (typeof detail === "object" && detail !== null
      && detail.isAxiosError && detail.response) {
    const serverDetail = detail.response.data && detail.response.data.detail;
    if (serverDetail != null) return formatApiError(serverDetail);
    if (typeof detail.message === "string" && detail.message) {
      return detail.message;
    }
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
